import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheckSquare, faClock, faTimes, faUndo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BButton, BButtonGroup } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, ref, watch } from "vue";
import { userOwnsHistory } from "@/api";
import { HistoryFilters } from "@/components/History/HistoryFilters";
import { Toast } from "@/composables/toast";
import { useHistoryStore } from "@/stores/historyStore";
import { useUserStore } from "@/stores/userStore";
import localize from "@/utils/localization";
import MultipleViewList from "./MultipleViewList.vue";
import FilterMenu from "@/components/Common/FilterMenu.vue";
import Heading from "@/components/Common/Heading.vue";
import SelectorModal from "@/components/History/Modals/SelectorModal.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MultipleView',
    setup(__props) {
        const filter = ref("");
        const showAdvanced = ref(false);
        const showSelectModal = ref(false);
        const initialLoaded = ref(false);
        library.add(faCheckSquare, faClock, faTimes, faUndo);
        const { currentUser } = storeToRefs(useUserStore());
        const { histories, currentHistory, historiesLoading } = storeToRefs(useHistoryStore());
        const historyStore = useHistoryStore();
        const selectedHistories = computed(() => {
            if (hasPinnedHistories.value) {
                return historyStore.pinnedHistories;
            }
            else {
                // get the latest four histories
                return [...histories.value]
                    .filter((h) => userOwnsHistory(currentUser.value, h))
                    .sort((a, b) => {
                    if (a.update_time < b.update_time) {
                        return 1;
                    }
                    else {
                        return -1;
                    }
                })
                    .slice(0, 4)
                    .map((history) => {
                    return { id: history.id };
                });
            }
        });
        // On mounted, wait for history store to load, then set `initialLoaded` to true
        watch(() => historiesLoading.value, (loading) => {
            if (!loading && histories.value.length > 0 && !initialLoaded.value) {
                initialLoaded.value = true;
            }
        }, { immediate: true });
        /** computed ref that indicates whether the user has histories pinned */
        const hasPinnedHistories = computed(() => Object.keys(historyStore.pinnedHistories).length > 0);
        /**
         * From the incoming list, pin histories that are not already pinned and
         * unpin histories that are not in the incoming list.
         * This is a mechanism to allow users to select or deselect histories in modal.
         * @param incomingHistories the incoming list of histories to pin
         */
        function addHistoriesToList(incomingHistories) {
            if (incomingHistories.length === 0) {
                showRecent();
                return;
            }
            // Pin histories that are in incoming list and aren't already pinned
            incomingHistories.forEach((history) => {
                const historyExists = historyStore.pinnedHistories.some((h) => h.id === history.id);
                if (!historyExists) {
                    historyStore.pinHistory(history.id);
                }
            });
            // Unpin histories that are already pinned but not in the incoming list
            const historiesToUnpin = historyStore.pinnedHistories
                .filter((pinnedHistory) => !incomingHistories.some((history) => history.id === pinnedHistory.id))
                .map((history) => history.id);
            historyStore.unpinHistories(historiesToUnpin);
        }
        const showRecentTitle = computed(() => {
            if (hasPinnedHistories.value) {
                return localize("Show 4 most recently updated histories instead");
            }
            else {
                return localize("Currently showing 4 most recently updated histories");
            }
        });
        /** Reset to _default_ state; showing 4 latest updated histories */
        function showRecent() {
            historyStore.pinnedHistories = [];
            Toast.info("Showing the 4 most recently updated histories. Pin histories to this view by clicking on Select Histories.", "History Multiview");
        }
        return { __sfc: true, filter, showAdvanced, showSelectModal, initialLoaded, currentUser, histories, currentHistory, historiesLoading, historyStore, selectedHistories, hasPinnedHistories, addHistoriesToList, showRecentTitle, showRecent, faCheckSquare, faClock, faUndo, FontAwesomeIcon, BAlert, BButton, BButtonGroup, HistoryFilters, localize, MultipleViewList, FilterMenu, Heading, SelectorModal, LoadingSpan };
    }
});
